import React from "react";
import { Link } from "react-router-dom";
import Ourwork from "../component/Ourwork";
import CustomSlider from "../component/HomeSlider";

// Services data remains the same
const services = [
  {
    id: 1,
    content: "Web Development",
    addcontent: "Custom websites built with cutting-edge technologies for optimal user experience and business growth.",
    imageUrl: "./webi.jpg",
    url: "/web-development"
  },
  {
    id: 2,
    content: "Mobile App Development",
    addcontent: "Native and cross-platform mobile solutions designed to extend your reach and engage users.",
    imageUrl: "./mobilei.jpg",
    url: "/mobile-development"
  },
  {
    id: 3,
    content: "UI/UX Design",
    addcontent: "User-centered design approaches that transform ideas into intuitive and visually stunning interfaces.",
    imageUrl: "./uiux.jpg",
    url: "/ui-ux-design"
  },
  {
    id: 4,
    content: "Data Analytics",
    addcontent: "Transform raw data into actionable insights that drive strategic decision-making and business growth.",
    imageUrl: "./data-analytics.webp",
    url: "/data-analytics"
  },
  {
    id: 5,
    content: "Cloud Solutions",
    addcontent: "Scalable cloud infrastructure to power your applications and streamline your operations.",
    imageUrl: "./cloud-solutions.webp",
    url: "/cloud-solutions"
  },
  {
    id: 6,
    content: "IT Consulting",
    addcontent: "Strategic technology guidance to align your IT investments with your business objectives.",
    imageUrl: "./it-consulting.webp",
    url: "/it-consulting"
  },
  {
    id: 7,
    content: "Cybersecurity",
    addcontent: "Comprehensive security solutions to protect your business from evolving digital threats.",
    imageUrl: "./cybersecurity.webp",
    url: "/cybersecurity"
  }
];

const Home = () => {
  return (
    <div className="bg-gradient-to-b from-[#f9f1ed] to-[#fff] min-h-screen">
      {/* Full-width hero section with custom slider integration */}
      <div className="relative">
        <CustomSlider />
        {/* <div className="absolute inset-0 bg-gradient-to-r from-[#3e2723]/70 to-transparent flex items-center">
          <div className="container mx-auto px-4 md:px-8 lg:px-16">
            <div className="max-w-2xl">
              <span className="inline-flex items-center bg-[#b87268] text-white px-3 py-1 rounded-full text-sm font-medium">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
                </svg>
                Elevate Your Business with ETL Services
              </span>
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mt-4 leading-tight">
                Grow Your Business Potential with Expert Technology Solutions
              </h1>
              <p className="text-white/90 text-lg mt-6 mb-8">
                In today's digital landscape, your success relies on innovative and 
                efficient technology strategies. Expert Vision Technology is here to 
                transform your business operations and drive growth!
              </p>
              <div className="flex flex-wrap gap-4">
                <Link
                  to="/contact"
                  className="bg-[#8d6e63] font-semibold duration-200 hover:bg-[#a1887f] text-white px-8 py-4 rounded-full shadow-lg"
                >
                  Get Started Today
                </Link>
                <Link
                  to="/services"
                  className="bg-white/20 backdrop-blur-sm font-semibold duration-200 hover:bg-white/30 border border-white/50 text-white px-8 py-4 rounded-full"
                >
                  Explore Services
                </Link>
              </div>
            </div>
          </div>
        </div> */}
      </div>

      {/* Main Content Container */}
      <div className="container mx-auto px-4 md:px-8">
        {/* Services Highlight Section - Card-based Grid */}
        <div className="py-24">
          <div className="text-center mb-16">
            <span className="bg-[#b87268] text-white px-3 py-1 rounded-md text-sm font-medium">
              Our Expertise
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-[#3e2723] mt-4">
              Explore Our Technology Services
            </h2>
            <p className="text-[#5d4037] mt-4 max-w-2xl mx-auto">
              Expert Vision Technology offers comprehensive solutions designed to transform your business operations and drive digital innovation. Each service is customized to meet your specific needs.
            </p>
          </div>
          
          {/* Featured Services - Interactive Cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
            {services.slice(0, 3).map((service) => (
              <Link 
                to={service.url}
                key={service.id}
                className="group rounded-xl overflow-hidden shadow-xl transition-all duration-300 hover:shadow-2xl bg-white hover:translate-y-[-8px]"
              >
                <div className="h-48 overflow-hidden relative">
                  <div
                    style={{
                      backgroundImage: `url(${service.imageUrl})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                    }}
                    className="absolute inset-0 transform transition-transform duration-500 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#3e2723] to-transparent opacity-80" />
                </div>
                <div className="p-6">
                  <h3 className="text-2xl font-bold text-[#3e2723] mb-2">{service.content}</h3>
                  <p className="text-[#5d4037]">{service.addcontent}</p>
                  <div className="mt-4 flex items-center text-[#b87268] font-medium">
                    Learn More
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 ml-2 group-hover:translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                    </svg>
                  </div>
                </div>
              </Link>
            ))}
          </div>
          
          {/* Additional Services - Streamlined Layout */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {services.slice(3).map((service) => (
              <Link
                to={service.url}
                key={service.id}
                className="group bg-[#f3e0dc] rounded-lg p-6 flex flex-col hover:bg-[#e8d0c9] transition-all duration-300"
              >
                <h3 className="text-xl font-bold text-[#3e2723] mb-2">{service.content}</h3>
                <p className="text-sm text-[#5d4037] mb-4 flex-grow">{service.addcontent}</p>
                <div className="flex items-center text-[#b87268] font-medium">
                  Learn More
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-1 group-hover:translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                  </svg>
                </div>
              </Link>
            ))}
          </div>
        </div>

        {/* Client Commitment Section - With Image */}
        <div className="py-16 bg-white rounded-2xl shadow-lg overflow-hidden">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            <div className="relative p-8 lg:p-16 flex items-center">
              <div className="relative z-10">
                <h2 className="text-4xl font-bold text-[#3e2723] mb-6">
                  Our Commitment to Client Success
                </h2>
                <p className="text-[#5d4037] text-lg mb-8">
                  At Expert Vision Technology, we're dedicated to your business growth. 
                  Our commitment to excellence ensures that every solution we deliver 
                  exceeds expectations.
                </p>
                <ul className="space-y-4 mb-8">
                  <li className="flex items-start">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-[#b87268] mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="text-[#5d4037]">Strategic technology implementation that drives measurable results.</span>
                  </li>
                  <li className="flex items-start">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-[#b87268] mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="text-[#5d4037]">Dedicated partnerships focused on long-term business success.</span>
                  </li>
                  <li className="flex items-start">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-[#b87268] mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="text-[#5d4037]">Continuous innovation to keep you ahead of industry trends.</span>
                  </li>
                </ul>
                <Link
                  to="/contact-us"
                  className="bg-[#8d6e63] font-semibold duration-200 hover:bg-[#a1887f] text-white px-8 py-3 rounded-full inline-flex items-center"
                >
                  Work With Us
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 ml-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                  </svg>
                </Link>
              </div>
              <div className="absolute top-10 right-10 opacity-10">
                <img
                  className="w-32 animate-pulse"
                  src="./world.webp"
                  alt="world"
                />
              </div>
            </div>
            <div className="overflow-hidden lg:rounded-l-3xl">
              <img
                className="w-full h-full object-cover"
                src="./Section4homepage.webp"
                alt="Client Success"
              />
            </div>
          </div>
        </div>

        {/* Advantages Grid - Streamlined Cards */}
        <div className="py-24">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-[#3e2723]">Why Choose Us</h2>
            <p className="text-[#5d4037] mt-4 max-w-2xl mx-auto">
              Our team brings together the expertise, support, and value you need to achieve remarkable results.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow border-t-4 border-[#b87268]">
              <div className="bg-[#f3e0dc] p-4 rounded-full inline-block mb-6">
                <img
                  width={30}
                  src="./usericonsection4.svg"
                  alt="Expert Team Icon"
                />
              </div>
              <h3 className="text-2xl font-bold text-[#3e2723] mb-4">Certified Technology Experts</h3>
              <p className="text-[#5d4037]">
                Our team of certified technologists brings decades of industry experience to solve your most complex business challenges.
              </p>
            </div>
            
            <div className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow border-t-4 border-[#b87268]">
              <div className="bg-[#f3e0dc] p-4 rounded-full inline-block mb-6">
                <img
                  width={30}
                  src="./headphonesection4.svg"
                  alt="Customer Service Icon"
                />
              </div>
              <h3 className="text-2xl font-bold text-[#3e2723] mb-4">Responsive Support</h3>
              <p className="text-[#5d4037]">
                We're available 24/7 with dedicated support teams ready to address your technical needs and questions promptly.
              </p>
            </div>
            
            <div className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow border-t-4 border-[#b87268]">
              <div className="bg-[#f3e0dc] p-4 rounded-full inline-block mb-6">
                <img
                  width={30}
                  src="./dollarsection4.svg"
                  alt="Pricing Icon"
                />
              </div>
              <h3 className="text-2xl font-bold text-[#3e2723] mb-4">Transparent Value Pricing</h3>
              <p className="text-[#5d4037]">
                Our pricing structure is transparent and designed to deliver maximum value for your technology investment.
              </p>
            </div>
          </div>
        </div>


        
        {/* Projects Showcase */}
        <div className="py-16">
          <Ourwork />
        </div>
        
        {/* Call to Action Section - Bold Design */}
        <div className="py-16">
          <div className="relative bg-[#3e2723] rounded-2xl overflow-hidden">
            <div className="absolute inset-0 opacity-10">
              <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
                <defs>
                  <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse">
                    <path d="M 40 0 L 0 0 0 40" fill="none" stroke="white" strokeWidth="1"/>
                  </pattern>
                </defs>
                <rect width="100%" height="100%" fill="url(#grid)" />
              </svg>
            </div>
            <div className="relative z-10 p-8 md:p-16 text-center">
              <h2 className="text-3xl md:text-5xl font-bold text-white mb-6">Ready to Accelerate Your Business?</h2>
              <p className="text-white/80 text-lg max-w-2xl mx-auto mb-10">
                Partner with Expert Vision Technology and unlock innovative solutions tailored to your unique business challenges.
              </p>
              <div className="flex flex-col sm:flex-row justify-center items-center gap-4">
                <Link
                  to="/contact-us"
                  className="bg-[#b87268] font-semibold duration-200 hover:bg-[#a1887f] text-white px-8 py-4 rounded-full w-full sm:w-auto"
                >
                  Schedule a Consultation
                </Link>
                <Link
                  to="/services"
                  className="bg-transparent font-semibold duration-200 hover:bg-white/10 border-2 border-white text-white px-8 py-4 rounded-full w-full sm:w-auto"
                >
                  Explore All Services
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;